import React from 'react'

const SvgInfo = props => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.fill}
      fillRule="evenodd"
      d="M16 0c8.836 0 16 5.97 16 13.333 0 6.799-6.11 12.396-14 13.219l-5.056 5.056-.004.004c-.112.11-.243.192-.38.255-.04.02-.084.03-.127.046a1.35 1.35 0 0 1-.35.07c-.028.002-.054.017-.083.017-.017 0-.032-.01-.05-.01a1.291 1.291 0 0 1-.46-.091c-.002 0-.003-.002-.005-.003-.012-.004-.02-.013-.032-.019a1.373 1.373 0 0 1-.353-.238c-.035-.032-.061-.067-.092-.103a1.265 1.265 0 0 1-.187-.277c-.021-.043-.044-.082-.061-.126a1.347 1.347 0 0 1-.093-.466v-4.775C4.457 24.06 0 19.137 0 13.333 0 5.971 7.164 0 16 0zm0 2.667c-7.352 0-13.333 4.785-13.333 10.666 0 4.436 3.518 8.456 8.754 10.002a2.665 2.665 0 0 1 1.912 2.557v1.556l2.782-2.783a2.668 2.668 0 0 1 1.609-.765c6.619-.69 11.61-5.233 11.61-10.567 0-5.881-5.982-10.666-13.334-10.666zm0 16a1.334 1.334 0 1 1-.001 2.667A1.334 1.334 0 0 1 16 18.667zm0-13.334c.733 0 1.333.6 1.333 1.334v8c0 .733-.6 1.333-1.333 1.333s-1.333-.6-1.333-1.333v-8c0-.734.6-1.334 1.333-1.334z"
    />
  </svg>
)

export default SvgInfo
